import { getJson } from '@shareuc/share';
import { useMount } from 'ahooks';
import { ConfigProvider } from 'antd';
import { observer } from 'mobx-react-lite';
import { RouterProvider } from 'react-router-dom';
import { useStoreGlobal } from './hooks';
import { getBrandPath } from './lib';
import { router } from './router';
import { IProductListData } from './types';
import { IBrandData } from './types/brand';

const App = observer(() => {
  const {
    store: storeGlobal,
    setProductListData,
    setBranddata,
  } = useStoreGlobal();

  useMount(() => {
    getJson<IProductListData>('editor/json/products_virtualsample', {
      dev: true,
    }).then((data) => {
      if (data) {
        setProductListData(data);
      }
    });

    const brand = getBrandPath();
    getJson<IBrandData>(`editor/json/${brand}`).then((data) => {
      if (data) {
        setBranddata(data);
      }
    });
  });

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: storeGlobal.colorPrimary,
          },
        }}
      >
        <RouterProvider router={router} />
      </ConfigProvider>
    </>
  );
});

export default App;
